import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
// import yandexMaps from './plugins/yandexMaps';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';

Vue.config.productionTip = false;

Vue.prototype.$url_isist = process.env.URL_ISIST || 'https://auzk.introscan.ru/';

new Vue({
  vuetify,
  // yandexMaps,
  render: (h) => h(App),
}).$mount('#app');
